module.exports = __webpack_public_path__ + "media/src/fonts/fontawesome-webfont-8b43027f47b20503057dfbbaa9401fef.eot";